module.exports = __webpack_public_path__ + "img/under-leaf.cbddd668.png";